import React from 'react';
import { Route, Redirect, Switch } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Register from './components/Authentication/Register';

import UserLogin from './components/Authentication/Login';
import Callback from './components/Authentication/Callback';
import UserLogout from './components/Authentication/Logout';
import SelectAccount from './components/Authentication/SelectAccount';
import UserProfile from './components/Authentication/ProfileDialog';
import VerifyEmail from './components/Authentication/VerifyEmail';
import AccountsService from './utils/AccountsService';
import { getProfile } from './utils/authenticated';

import Home from './components/Home';
import CustomersView from './components/Customers/CustomersView';
import EmployeesView from './components/Employees/EmployeesView';
import JobProfilesView from './components/Admin/JobProfiles/JobProfilesView';
import TaskProfilesView from './components/Admin/TaskProfiles/TaskProfilesView';
import JobsView from './components/Jobs/JobsView';
import SchedulingView from './components/Scheduling';
import AdminView from './components/Admin';
import BillingView from './components/Admin/Billing/BillingView';
import RolesView from './components/Admin/Roles/RolesView';
import Settings from './components/Settings';
import PrintersView from './components/Admin/Printers/PrintersView';

import JobReport from './components/Reports/JobReport';
import ItemBreakdownReport from './components/Reports/ItemBreakdownReport';
import DetailedItemBreakdownReport from './components/Reports/DetailedItemBreakdownReport';
import Exceptions from './components/Reports/ExceptionsReport';

import { loginRoutine } from './redux/routines';
import AuthService from './utils/AuthService';

const Authenticated = (WrappedComponent) => (props) => {
  const user = getProfile();
  if (!AuthService.loggedIn() || !user) {
    console.log('1');
    return <Redirect to="/login"/>;
  }
  if (!user.email_verified) {
    console.log('2');
    return <VerifyEmail/>;
  }

  return (<WrappedComponent {...props}/>);
};

const Authorized = (allowedPermissions) =>
  (WrappedComponent) => (props) => {
    const user = getProfile();
    const account = AccountsService.getAccount();

    if (!user || !account) {
      console.log('Authorized - no - redirecting');
      return <Redirect to="/login"/>;
    }

    // TODO reiew re-instating
    // const allowed = (account.permissions || []).find((permission) => allowedPermissions.includes(permission));

    // if (allowed) {
    return (<WrappedComponent {...props} />);
    // }
    //
    // return (<NotAuthorized/>);
  };

const AuthorizedUser = Authorized(['ReadOnly', 'JobCreator', 'Administrator']);
const AdminUser = Authorized(['Administrator']);

class AppView extends React.Component {
  componentWillMount() {
    AuthService.getLock().on('authenticated', (authResult) => {
      this.props.login(authResult);
      // console.log('firebaseAuth.currentUser', firebaseAuth.currentUser);
    });

    // this.props.fetchUser();
  }

  render() {
    return (<ConnectedRouter history={this.props.history}>
      <Switch>
        <Route path="/register" component={Register}/>

        <Route path="/login" component={UserLogin}/>
        <Route path="/callback" component={Callback}/>
        <Route path="/account" component={Authenticated(SelectAccount)}/>
        <Route path="/logout" component={UserLogout}/>
        {/*<Route path="/changepassword" component={ChangePassword}/>*/}
        <Route path="/verifyemail" component={VerifyEmail}/>

        <Route path="/" component={AuthorizedUser(Home)} exact/>
        <Route path="/profile" component={AuthorizedUser(UserProfile)}/>
        <Route path="/customers" component={AuthorizedUser(CustomersView)}/>
        <Route path="/employees" component={AuthorizedUser(EmployeesView)}/>
        <Route path="/jobs" exact component={AuthorizedUser(JobsView)}/>
        {/*<Route path="/taskprofile" component={AuthorizedUser(TaskProfileDial)}/>*/}
        <Route path="/scheduling" component={AuthorizedUser(SchedulingView)}/>
        <Route path="/reports/jobreport/:jobId" component={AuthorizedUser(JobReport)}/>
        {/*<Route path="/reports/jobreport/:jobId" component={JobReport}/>*/}
        <Route path="/reports/exceptions/:jobId" component={AuthorizedUser(Exceptions)}/>
        <Route path="/reports/itembreakdown/:jobId" component={AuthorizedUser(ItemBreakdownReport)}/>
        <Route
          path="/reports/detaileditembreakdown/:jobId"
          component={AuthorizedUser(DetailedItemBreakdownReport)}/>

        <Route path="/admin" component={AdminUser(AdminView)} exact/>
        <Route path="/admin/roles" component={AdminUser(RolesView)}/>
        <Route path="/admin/jobprofiles" component={AuthorizedUser(JobProfilesView)}/>
        {/*<Route path="/jobprofiles/:jobProfileId" component={AuthorizedUser(JobProfile)}/>*/}
        <Route path="/admin/taskprofiles" component={AuthorizedUser(TaskProfilesView)}/>
        {/*<Route path="/taskprofiles/:taskProfileId" component={AuthorizedUser(TaskProfile)}/>*/}
        <Route path="/admin/printers" component={AuthorizedUser(PrintersView)}/>
        {/*<Route path="/printer/:printerId" component={AuthorizedUser(Printer)}/>*/}
        <Route path="/admin/billing" component={AdminUser(BillingView)}/>
        <Route path="/admin/settings" component={AdminUser(Settings)}/>
      </Switch>
    </ConnectedRouter>);
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    login: loginRoutine.trigger,
    // fetchUser: fetchUserRoutine.trigger,
  }, dispatch);
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(AppView);



// WEBPACK FOOTER //
// ./src/AppView.js